// Contagem de estoque (desktop e mobile): quando a diferença encontrada é
// de ENTRADA (contada > estoque), o operador pode detalhar em quantos
// vencimentos diferentes o TOTAL contado está dividido — não só a
// diferença. Ex.: sistema tinha 40, contou 50 (diferença +10), mas os 50
// podem estar divididos em 20 vencendo em outubro + 30 em dezembro; é
// essa composição inteira (até 50) que o operador declara, não só os 10
// que sobraram. Por isso os lotes declarados numa contagem SUBSTITUEM os
// que já existiam pra esse produto (decisão da usuária — a contagem é a
// foto nova da prateleira, não um acréscimo por cima da anterior).
//
// O estoque em si só muda pela DIFERENÇA, como sempre — os lotes ficam
// desacoplados disso (ver backend/estoqueController.registrarLotesItem).
//
// Diferença de SAÍDA (contada < estoque) nunca leva vencimento: não dá
// pra saber de qual lote já cadastrado a baixa saiu sem uma tela de
// escolha de lote, que esse fluxo não tem — decisão tomada com a usuária.
//
// `item` esperado: { produto_id, descricao, estoque (ou estoque_atual),
// contada (ou quantidade_contada), setor_id, data_hora?, vencimentos?:
// [{quantidade, data_vencimento}] } — vencimentos pode somar até `contada`.
export function expandirItemContagem(item, setorPadrao) {
  const estoque = parseFloat(item.estoque ?? item.estoque_atual ?? 0);
  const contada = parseFloat(item.contada ?? item.quantidade_contada ?? 0);
  const diferenca = contada - estoque;
  const vencimentos = diferenca > 0 ? (item.vencimentos || []).filter(v => parseFloat(v.quantidade) > 0) : [];

  return [{
    produto_id: item.produto_id,
    descricao: item.descricao,
    setor_id: item.setor_id || setorPadrao || null,
    ...(item.data_hora ? { data_hora: item.data_hora } : {}),
    quantidade: Math.abs(diferenca),
    operacao: diferenca > 0 ? 'entrada' : 'saida',
    estoque_snapshot: estoque,
    quantidade_contada: contada,
    // `lotes` só vai no payload quando o operador REALMENTE detalhou pelo
    // menos um vencimento — é o que liga o modo SUBSTITUI no backend
    // (apaga os lotes antigos desse produto e grava só o que foi
    // declarado agora). Uma contagem comum, sem mexer em vencimento
    // nenhum, não pode apagar lote de ninguém por acidente só por ter
    // dado diferença positiva — por isso `lotes` fica de fora (undefined)
    // quando `vencimentos` está vazio, em vez de mandar `[]`.
    ...(vencimentos.length ? { lotes: vencimentos.map(v => ({ quantidade: parseFloat(v.quantidade), data_vencimento: v.data_vencimento })) } : {}),
  }];
}

// Soma das quantidades já detalhadas por vencimento — usado pra avisar o
// operador se ultrapassou o total contado disponível pra distribuir.
export function somaVencimentos(vencimentos) {
  return (vencimentos || []).reduce((a, v) => a + (parseFloat(v.quantidade) || 0), 0);
}
